/* ==========================================================================
   WNX Carousel — 3 việc trong một file:
     1. Ghi lại sản phẩm khách vừa xem (localStorage, tối đa 9, mới nhất đứng trước)
     2. Đổ thẻ vào "Recently viewed" bằng Section Rendering API
     3. Gắn nút mũi tên cho cả hai đường ray

   Vì sao phải gọi Section Rendering API thay vì lưu sẵn giá vào localStorage:
   store hiển thị giá theo country. Cùng Shadow Bed Kit, products.json trả 59.95
   nhưng khách UK nhìn thấy £45.00. Lưu giá lúc xem rồi in lại là sai ngay khi
   khách đổi nước, hoặc khi đợt giảm giá kết thúc. Nên chỉ lưu handle, còn giá và
   tình trạng còn hàng để Liquid render lại mỗi lần.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'wnx_recently_viewed';
  var MAX = 9;

  /* ---------- localStorage: đọc / ghi danh sách handle ---------- */

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      // Chế độ riêng tư của Safari và một số trình duyệt chặn localStorage.
      // Không có lịch sử thì section tự ẩn, không được để nó ném lỗi ra ngoài.
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* hết dung lượng hoặc bị chặn: bỏ qua, không ảnh hưởng phần còn lại của trang */
    }
  }

  function track(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  /* ---------- Mũi tên, dùng chung cho cả hai đường ray ---------- */

  function initNav(rail, nav) {
    if (!rail || !nav) return function () {};
    var arrows = Array.prototype.slice.call(nav.querySelectorAll('.wnx-arrow'));

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      // Không có gì để cuộn thì giấu hẳn cụm mũi tên đi
      nav.style.display = max < 4 ? 'none' : '';
      arrows.forEach(function (a) {
        var dir = parseInt(a.getAttribute('data-dir'), 10);
        var atStart = rail.scrollLeft <= 2;
        var atEnd = rail.scrollLeft >= max - 2;
        if (dir < 0 ? atStart : atEnd) {
          a.setAttribute('disabled', '');
        } else {
          a.removeAttribute('disabled');
        }
      });
    }

    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        var card = rail.querySelector('.wnx-card, .collection-list__item');
        var step = card ? card.getBoundingClientRect().width + 8 : 188;
        rail.scrollBy({ left: parseInt(a.getAttribute('data-dir'), 10) * step * 2 });
      });
    });

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // Đo một lần lúc khởi động là chưa đủ: thời điểm đó ảnh trong thẻ chưa tải nên
    // scrollWidth vẫn bằng clientWidth, update() kết luận "không có gì để cuộn" rồi
    // giấu luôn cụm mũi tên, và không bao giờ tính lại. Đã dính đúng lỗi này: dải
    // 8 collection cuộn được nhưng nút vẫn mất tăm.
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(update);
      ro.observe(rail);
    }
    window.addEventListener('load', update);

    update();
    return update;
  }

  function arrowMarkup(dir, label) {
    var path = dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
    return (
      '<button class="wnx-arrow" type="button" data-dir="' + dir + '" aria-label="' + label + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' + path + '" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
    );
  }

  /* ---------- "Our Collections": biến lưới sẵn có thành carousel ----------
     Chỉ chèn cụm mũi tên vào hàng tiêu đề. Phần biến lưới thành đường ray do CSS
     lo, nên nếu file JS này hỏng hay tải chậm thì khối đó vẫn là carousel cuộn
     tay được, chỉ thiếu mũi tên. */

  function initCollectionList() {
    // CSS đã tự nhận biết trang bằng body:has(#wnx-recently-viewed), nên ở đây chỉ
    // cần tìm các khối collection-list có sẵn rồi gắn mũi tên vào.
    if (!document.getElementById('wnx-recently-viewed')) return;

    var sections = document.querySelectorAll('.collection-list-wrapper');
    Array.prototype.forEach.call(sections, function (sec) {
      var rail = sec.querySelector('.collection-list');
      if (!rail || sec.querySelector('.wnx-nav')) return;

      var head = sec.querySelector('.title-wrapper-with-link');
      if (!head) return;

      var nav = document.createElement('div');
      nav.className = 'wnx-nav';
      nav.innerHTML =
        arrowMarkup(-1, 'Previous collections') + arrowMarkup(1, 'More collections');
      head.appendChild(nav);
      initNav(rail, nav);
    });
  }

  /* ---------- "Recently viewed": đổ thẻ vào ---------- */

  function renderRecentlyViewed(sec) {
    var rail = sec.querySelector('.wnx-rail');
    var nav = sec.querySelector('.wnx-nav');
    var current = sec.getAttribute('data-current-handle') || '';

    var handles = read()
      .filter(function (h) { return h !== current; })  // đang mở sản phẩm nào thì bỏ nó ra
      .slice(0, MAX);

    // Dưới 2 món thì không render. Một hàng chỉ có 1 thẻ trông như trang bị lỗi.
    if (handles.length < 2) return;

    var base = sec.getAttribute('data-card-url') || '/products/';

    Promise.all(
      handles.map(function (handle) {
        return fetch(base + handle + '?section_id=wnx-rv-card', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })
    ).then(function (chunks) {
      var frag = document.createElement('div');
      chunks.forEach(function (html) {
        if (!html) return;
        // Section Rendering API trả nguyên vỏ div của section, lấy phần thẻ bên trong
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var card = tmp.querySelector('.wnx-card');
        if (card) frag.appendChild(card);
      });

      // Sản phẩm bị gỡ khỏi store sẽ trả về rỗng, nên đếm lại sau khi ghép
      if (frag.children.length < 2) return;

      rail.innerHTML = '';
      while (frag.firstChild) rail.appendChild(frag.firstChild);

      sec.classList.remove('wnx-sec--empty');
      sec.removeAttribute('hidden');
      var update = initNav(rail, nav);
      update();
    });
  }

  /* ---------- Bỏ một món khỏi danh sách ---------- */

  function initRemove(sec) {
    sec.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.wnx-card__remove') : null;
      if (!btn) return;
      e.preventDefault();

      var card = btn.closest('.wnx-card');
      var handle = card && card.getAttribute('data-handle');
      if (handle) write(read().filter(function (h) { return h !== handle; }));
      if (card) card.remove();

      var rail = sec.querySelector('.wnx-rail');
      // Còn dưới 2 thẻ thì cất cả khối đi, cùng quy tắc với lúc render
      if (rail && rail.children.length < 2) {
        sec.setAttribute('hidden', '');
        sec.classList.add('wnx-sec--empty');
      }
    });
  }

  /* ---------- Khởi động ---------- */

  function init() {
    // Ghi lại sản phẩm của trang hiện tại, làm trước để lần sau vào là có
    var meta = document.querySelector('[data-wnx-product-handle]');
    if (meta) track(meta.getAttribute('data-wnx-product-handle'));

    initCollectionList();

    var sec = document.getElementById('wnx-recently-viewed');
    if (sec) {
      initRemove(sec);
      renderRecentlyViewed(sec);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
